// extracted by mini-css-extract-plugin
export default {"productnavbar":"CartNavar_productnavbar__WyKGy"};